import { api } from "../../libs/axios";

export async function consultarLinkPagamento(id: string) {
  const response = await api.get(`/checkout/link-pagamento/consultar/${id}`);

  return response.data;
}

